import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ConfigurationService } from '../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class GeneralinformationService {

  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  apiUrl = this.ConfigService.getAPIBaseUrl() + 'api/GeneralInformation/';

  addinformation(data: any) {
    debugger
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
    return this.http.post(this.apiUrl + 'InsertInformation', data, httpOptions)
  }

  getinformation(id) {
    debugger
    return this.http.get(this.apiUrl + 'GetInformation?id=' + id)
  }
}
